import { getAuth } from "firebase/auth";
import { logger } from '../utils/logger';
import { authAxios } from '../utils/apiConfig';

const domainAxios = authAxios;

// Get domain overview data
export async function getDomainOverview(domain, country = 'US') {
  try {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      logger.error('No authenticated user found');
      throw new Error('Authentication required');
    }

    const response = await domainAxios.get('/spyfu/domain-overview', {
      params: {
        user: user.email,
        domain: domain,
        country: country
      }
    });

    return response.data;
  } catch (error) {
    logger.error("Error in getDomainOverview:", error);
    if (error.response) {
      logger.error("Server response:", error.response.data);
      throw new Error(error.response.data.message || error.response.data.detail || 'Server error');
    }
    throw error;
  }
}

// Get domain stats data
export async function getDomainStats(domain, country = 'US') {
  try {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      logger.error('No authenticated user found');
      throw new Error('Authentication required');
    }

    const response = await domainAxios.get('/spyfu/domain-stats', {
      params: {
        user: user.email,
        domain: domain,
        country: country
      }
    });

    return response.data;
  } catch (error) {
    logger.error("Error in getDomainStats:", error);
    if (error.response) {
      logger.error("Server response:", error.response.data);
      throw new Error(error.response.data.message || error.response.data.detail || 'Server error');
    }
    throw error;
  }
}

// Get organic keywords for a domain
export async function getDomainOrganicKeywords(domain, country = 'US', page = 1, pageSize = 100) {
  try {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      logger.error('No authenticated user found');
      throw new Error('Authentication required');
    }

    const response = await domainAxios.get('/spyfu/organic-keywords', {
      params: {
        user: user.email,
        domain: domain,
        country: country,
        page: page,
        page_size: pageSize
      }
    });

    return response.data;
  } catch (error) {
    logger.error("Error in getDomainOrganicKeywords:", error);
    if (error.response) {
      logger.error("Server response:", error.response.data);
      throw new Error(error.response.data.message || error.response.data.detail || 'Server error');
    }
    throw error;
  }
}

// Get paid keywords for a domain
export async function getDomainPaidKeywords(domain, country = 'US', page = 1, pageSize = 100) {
  try {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      logger.error('No authenticated user found');
      throw new Error('Authentication required');
    }

    const response = await domainAxios.get('/spyfu/paid-keywords', {
      params: {
        user: user.email,
        domain: domain,
        country: country,
        page: page,
        page_size: pageSize
      }
    });

    return response.data;
  } catch (error) {
    logger.error("Error in getDomainPaidKeywords:", error);
    if (error.response) {
      logger.error("Server response:", error.response.data);
      throw new Error(error.response.data.message || error.response.data.detail || 'Server error');
    }
    throw error;
  }
}

// Get competitors for a domain
export async function getDomainCompetitors(domain, organic = true, country = 'US') {
  try {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      logger.error('No authenticated user found');
      throw new Error('Authentication required');
    }

    const response = await domainAxios.get('/spyfu/competitors', {
      params: {
        user: user.email,
        domain: domain,
        organic: organic,
        country: country
      }
    });

    return response.data;
  } catch (error) {
    logger.error("Error in getDomainCompetitors:", error);
    if (error.response) {
      logger.error("Server response:", error.response.data);
      throw new Error(error.response.data.message || error.response.data.detail || 'Server error');
    }
    throw error;
  }
}

// Get ad history for a domain
export async function getDomainAdHistory(domain, country = 'US', page = 1, pageSize = 100) {
  try {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      logger.error('No authenticated user found');
      throw new Error('Authentication required');
    }

    const response = await domainAxios.get('/spyfu/ad-history', {
      params: {
        user: user.email,
        domain: domain,
        country: country,
        page: page,
        page_size: pageSize
      }
    });

    return response.data;
  } catch (error) {
    logger.error("Error in getDomainAdHistory:", error);
    if (error.response) {
      logger.error("Server response:", error.response.data);
      throw new Error(error.response.data.message || error.response.data.detail || 'Server error');
    }
    throw error;
  }
}

// Get budget history for a domain
export async function getDomainBudgetHistory(domain, country = 'US') {
  try {
    const auth = getAuth();
    const user = auth.currentUser;

    if (!user) {
      logger.error('No authenticated user found');
      throw new Error('Authentication required');
    }

    const response = await domainAxios.get('/spyfu/budget-history', {
      params: {
        user: user.email,
        domain: domain,
        country: country
      }
    });

    return response.data;
  } catch (error) {
    logger.error("Error in getDomainBudgetHistory:", error);
    if (error.response) {
      logger.error("Server response:", error.response.data);
      throw new Error(error.response.data.message || error.response.data.detail || 'Server error');
    }
    throw error;
  }
}

// Export all functions as default object
export default {
  getDomainOverview,
  getDomainStats,
  getDomainOrganicKeywords,
  getDomainPaidKeywords,
  getDomainCompetitors,
  getDomainAdHistory,
  getDomainBudgetHistory
};
